import React from "react"
import SwiperCore, { Mousewheel, Keyboard } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import constants from "../constants"
import "swiper/swiper.scss"
import LocalsMenu from "./localsMenu.json"
import i18n from "../utils/i18n"
import Actions from "../actions"
import { navigate } from "gatsby"

SwiperCore.use([Mousewheel, Keyboard])

const MiniSlideshow = (props) => {
  const language = !props.lang ? `EN` : props.lang?.toUpperCase()
  const GroupPill = ({className, children}) => (
    <div className={`${className} rounded-full px-4 py-1 bg-black text-white ${constants.caption}`}>{children}</div>
  )
  const ImageWrapper = ({ className, children, to }) => {
    const onClick = () => {
      if (to) {
        if (window.location.pathname.indexOf(to) >= 0) {
          setTimeout(Actions.openLookbook)
        } else {
          navigate(`/${props.lang}/story/${to}?slideshow=true`)
        }
      }
    }
    return (
      <button style={{ outline: 0 }} onClick={onClick} className={`${className} w-full h-full`}>{children}</button>
    )
  }
  const blocks = props.items.map((item) => {
    const onVideoClicked = (video) => {
      setTimeout(Actions.launchVideo, 0, video, props.lang)
    }
    return item.blocks.map((block, index) => {
      return (
        <SwiperSlide style={{ width: `${block.asset.size === `lg` ? 230 : 190}px`, height: `240px` }} key={`${block.id}-${item.id}`}>
          <div className={`w-full h-full`}>
            <div className={`block text-left mb-4 ${index === 0 ? `visible` : `invisible`}`}>
              <GroupPill className={`inline-flex pb-1.5`}>{i18n(LocalsMenu, `title-${item.id}`, props.lang)}</GroupPill>
            </div>
            <div className={`w-full h-8/12 relative`}>
              { block.asset.src &&
              <div style={{transform: `translate3d(0, 0, 1px)`}} className={`w-full h-full`}>
                <ImageWrapper to={block.asset.to}>
                  <GatsbyImage
                    className={`w-full h-full rounded-4xl overflow-hidden`}
                    imgStyle={{ borderRadius: `2.0rem` }}
                    objectFit={`cover`}
                    image={getImage(block.asset.src.childImageSharp)}
                    alt={block.id}
                  />
                </ImageWrapper>
              </div>
              }
              { block.asset.colour &&
              <div
                className={`h-full rounded-4xl`}
                style={{ backgroundColor: block.asset.colour }}
              />
              }
              { block.asset.video &&
                <button onClick={() => onVideoClicked(block.asset.video)} style={{ outline: 0 }} className={`w-full h-full absolute top-0 left-0 block`}>
                  <div style={{transform: `translate3d(0, 0, 1px)`}} className={`w-full h-full flex flex-col justify-center text-white text-center`}>
                    <div className={`text-center w-full pt-2`}>
                      <svg className={`fill-current w-4 inline-block`} viewBox="0 0 30 33">
                        <path d="M0,0v33l30-16.5L0,0z"/>
                      </svg>
                    </div>
                    <div className={`w-full`}>({block.asset.video.duration})</div>
                  </div>
                </button>
              }
              { block.asset.download &&
              <div className={`w-full h-full absolute top-0 left-0`}>
                <a href={block.asset.download.absolute ? ( block.asset.download.to === `.zip` ? `https://stella-luna-cms.s3.eu-west-3.amazonaws.com/zip/${language}_2${block.asset.download.to}` : `${constants.BASE_URL}${block.asset.download.to}`) : block.asset.download.to} target={`_blank`} style={{transform: `translate3d(0, 0, 1px)`}} className={`w-full h-full flex flex-col justify-center text-white text-center`}>
                  <div className={`text-center w-full pt-2`}>
                    <svg className={`fill-current w-4 inline-block`} viewBox="0 0 16 30">
                      <path transform="translate(-9436.697 -892.601)" d="M9452.7,909.7l-8,7.8l-8-7.8l2.2-2.2l4,4.1v-18.9
                        h3.4v18.9l4-4.1L9452.7,909.7z M9436.7,919.6h15.9v3h-15.9V919.6z"/>
                    </svg>
                  </div>
                  <div>{i18n(LocalsMenu, `title-download`, props.lang)}</div>
                </a>
              </div>
              }
            </div>
            <p className={`${constants.caption} text-left w-full pt-2`}>{i18n(LocalsMenu, `title-${block.id}`, props.lang)}</p>
          </div>
        </SwiperSlide>
      )
    })
  })
  return (
    <div className={`${props.className} w-full`}>
      <div className={`w-full`}>
        <div className={`w-full pb-4 px-${constants.padmob} lg:pb-6 lg:px-${constants.pad}` }>
          <Swiper
            spaceBetween={28}
            slidesPerView={`auto`}
            freeMode={true}
            mousewheel={true}
            keyboard={true}
          >{blocks}</Swiper>
        </div>
      </div>
      <div style={{ height: `300px` }} className={`w-full absolute bottom-0 left-0 bg-gradient-to-t from-white`}/>
    </div>
  )
}

export default MiniSlideshow